export default {
  'menu.welcome': '首页',
  'menu.license': '许可信息',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.data-center': '数据报表',
  'menu.data-center.data-center-security': '安防工单数据',
  'menu.data-center.data-center-supervise': '违规预警数据',
  'menu.data-center.data-center-heat': '网点客流热力分析',
  'menu.data-center.data-center-voice': '语音场景统计',
  'menu.strategy': '策略管理平台',
  'menu.strategy.strategy-bank': '网点预警策略',
  'menu.strategy.strategy-workstatus': '工作状态策略',
  'menu.strategy.strategy-holiday': '节假日配置',
  'menu.emergency-index': '工单报警平台',
  'menu.monitor': '工单弹屏',
  'menu.voice-analysis': '星空多模态分析',
  'menu.emergency': '违规预警',
  'menu.emergency.supervise-query': '监管类事件',
  'menu.emergency.service-query': '服务类事件',
  'menu.emergency.tn-query': 'T+N事件',
  'menu.emergency.supervise-handle': '监管类批量处理',
  'menu.emergency.service-handle': '服务类批量处理',
  'menu.patrol-point': 'AI巡更管理',
  'menu.patrol-point.patrol-point-dashboard': '数据简报',
  'menu.patrol-point.patrol-point-nodes': '巡更点管理',
  'menu.patrol-point.patrol-point-tasks': '巡更任务调度',
  'menu.patrol-point.patrol-point-records': '巡更记录与核验',
  'menu.bank': '机构树管理',
  'menu.bank.bank-list': '银行/项目管理（一级）',
  'menu.bank.bank-branch': '支行管理（二级）',
  'menu.bank.bank-dept': '网点管理（三级）',
  'menu.user': '账号与角色',
  'menu.user.user-accounts': '账号管理',
  'menu.user.user-roles': '角色管理',
  'menu.device': '监控设备管理',
  'menu.device.nvr-secure': '安防类NVR',
  'menu.device.camera-secure': '安防类摄像机',
  'menu.device.nvr-supervise': '运营类NVR',
  'menu.device.camera-supervise': '运营类摄像机',
  'menu.device.robot': '机器人管理',
  'menu.maintenance': '运维中心',
  'menu.maintenance.ai-server': '设备节点管理',
  'menu.maintenance.server-config': '中心平台配置',
  'menu.maintenance.trouble-shooting': '设备节点故障',
  'menu.maintenance.face-lib': '人脸库管理',
  'menu.maintenance.face-trace': '人脸轨迹查询',
  'menu.maintenance.camera-trouble': '摄像机故障',
  'menu.maintenance.strategy-config': '出厂报警策略配置',
  'menu.log-operation': '日志',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
